<template>

  <div class="ob-list">

    <v-list v-if="items.length">
      <v-list-item v-for="(item, index) in items" :key="index" @click="$emit('select', item)">
        <v-list-item-avatar v-if="icon || ($scopedSlots && !!$scopedSlots.icon)">
          <slot name="icon" v-bind:item="item">
            <font-awesome-icon :icon="icon" size="lg" v-if="icon" />
          </slot>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            <slot v-bind:item="item"></slot>
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <slot name="actions" v-bind:item="item">
            <v-btn icon ripple @click.stop="$emit('remove', item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </slot>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <no-data v-if="!items.length">
      {{ noDataMessage }}
    </no-data>

  </div>

</template>

<script>
  import NoData from '../no-data'

  export default {
    name: 'ob-list',

    props: [ 'items', 'icon', 'noDataMessage' ],

    components: {
      NoData
    }
  }
</script>

<style scoped lang="scss">

  @import '../../../assets/variables';

  ::v-deep {
    .no-data {
      margin-top: $spacing-large;
      font-size: 20px;
    }

    .v-list-item {
      &__action {
        margin: 0;
      }

      &__avatar {
        height: auto !important;
      }

      &__content {
        padding: 0;
      }

      &__title {
        .v-input {
          margin-top: 5px;

          .v-messages {
            display: none;
          }
        }
      }
    }
  }

</style>
